import styled, { css } from 'styled-components';
import { DND_BASE_LAYER_Z_INDEX } from '../DndEntity/constants';
import { theme } from '../../styles/theme';
import { AnalyticsHtmlButton } from '../Button';

export const CONTAINER_WIDTH = 44;

export const FixedContainer = styled.div`
  height: 100%;
  width: ${CONTAINER_WIDTH}px;
  background-color: ${theme.colors.level1};
  position: fixed;
  top: 56px;
  right: 0;
  border-left: 1px solid ${theme.colors.border};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 12px;
  padding-bottom: 12px;
  z-index: ${DND_BASE_LAYER_Z_INDEX + 4};
`;

export const IconContainer = styled(AnalyticsHtmlButton)<{
  $isActive?: boolean;
}>`
  position: relative;
  flex: 0 0 auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  font: inherit;
  padding: 0;
  outline: none;
  color: ${theme.colors.secondary800};
  &:not(:disabled):hover {
    cursor: pointer;
    background-color: ${({ $isActive }) =>
      $isActive ? theme.colors.mainBlue : theme.colors.blue500};
  }
  &:disabled {
    color: ${theme.colors.secondary400};
  }
  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: ${theme.colors.mainBlue};
      color: ${theme.colors.white};
    `}
`;
